export default function isWindow() {
    return typeof window !== 'undefined';
}
